var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction-head default-interaction-head mb-0",class:[
    _vm.perspectiveClass,
    _vm.enabledFeatures.includes('hotspotStyling') ? '' : 'pt-2 px-2',
  ],attrs:{"tabindex":"0","aria-label":`Interaction text: ${_vm.interaction.interactionText.stripHTML({ makeScreenReaderFriendly: true })}`}},[_c('div',{staticClass:"pp-interaction-title",domProps:{"innerHTML":_vm._s(_vm.interaction.interactionText)}}),_c('InteractionAttachments',{attrs:{"attachments":_vm.interaction.interactionAttachments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }